/** @format */

import { put, select } from 'redux-saga/effects';
import { selectorSearchBody } from '../search/selectors';

export function* sagaFilter(): Generator<any> {
  const searchBody = yield select(selectorSearchBody);
  yield put({ type: 'SEARCH_RESULT_LIST_REQUEST', payload: searchBody });
}
